// 引入js，css文件
export const loadSrc = (url, domId, type) => {
  return new Promise((resolve, reject) => {
    if (!url) {
      reject(new Error("请设置加载资源的url"));
      return false;
    }
    if (!domId) {
      reject(new Error("请设置加载资源的dom Id"));
      return false;
    }
    if (document.getElementById(domId)) {
      resolve();
    } else {
      if (type === "css") {
        let cssLink = document.createElement("link");
        cssLink.id = domId;
        cssLink.type = "text/css";
        cssLink.rel = "stylesheet";
        cssLink.href = url;
        cssLink.onload = () => {
          resolve();
        };
        document.head.appendChild(cssLink);
      } else {
        let jsScript = document.createElement("script");
        jsScript.id = domId;
        jsScript.type = "text/javascript";
        jsScript.onload = () => {
          resolve();
        };
        jsScript.src = url;
        document.body.appendChild(jsScript);
      }
    }
  });
};

// 判断内容是否同时包含图片和文本--线索题
export const isImgAndText = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const p = doc.querySelector('p');
  if (!p) {
      return { isValide: false, hasImage: false, hasText: false };
  }
  const hasImage = p.querySelector('img') !== null;
  const textContent = p.textContent.trim();
  const hasText = textContent !== '';
  const isValide = (hasImage && !hasText) || (hasText && !hasImage);
  return { isValide, hasImage, hasText };
}



// WEBPACK FOOTER //
// ./src/utils/common-tools.js